import { render } from "./AuctionBidList.vue?vue&type=template&id=a4647262&scoped=true&ts=true"
import script from "./AuctionBidList.vue?vue&type=script&lang=ts"
export * from "./AuctionBidList.vue?vue&type=script&lang=ts"

import "./AuctionBidList.vue?vue&type=style&index=0&id=a4647262&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4647262"]])

export default __exports__